<mat-card class="cardWithShadow">
  <mat-card-content style="padding: 36px 36px 0px 36px">
    <h2>Servicios de Alimentos & Bebidas</h2>
    <p>
      En esta sección puedes asignar menús a los servicios de productos ya
      existente.
    </p>

    <div *ngIf="!isLoading" class="row justify-content-between">
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <mat-label>PROVEEDOR</mat-label>
          <mat-select
            [(value)]="selectProveedor"
            (selectionChange)="applyFilterSelect()"
          >
            <mat-option value="{{ null }}">No seleccionar</mat-option>
            <mat-option
              *ngFor="let proveedor of uniqueProviderNames"
              value="{{ proveedor }}"
              >{{ proveedor }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <mat-label>CATEGORÍA </mat-label>
          <mat-select
            [(value)]="selectCategoria"
            (selectionChange)="applyFilterSelect()"
          >
            <mat-option value="{{ null }}">No seleccionar</mat-option>
            <mat-option
              *ngFor="let categoria of uniqueServiceCategories"
              value="{{ categoria }}"
              >{{ categoria }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <mat-label>PRODUCTO </mat-label>
          <mat-select
            [(value)]="selectProducto"
            (selectionChange)="applyFilterSelect()"
          >
            <mat-option value="{{ null }}">No seleccionar</mat-option>
            <mat-option
              *ngFor="let producto of arrayProducto"
              value="{{ producto }}"
              >{{ producto }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <mat-label>AÑO</mat-label>
          <mat-select
            [(value)]="selectYear"
            (selectionChange)="applyFilterSelect()"
          >
            <mat-option value="{{ null }}">No seleccionar</mat-option>
            <mat-option
              *ngFor="let year of uniqueYearProducts"
              value="{{ year }}"
              >{{ year }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <mat-label>STATUS</mat-label>
          <mat-select
            [(value)]="selectStatus"
            (selectionChange)="applyFilterSelect()"
          >
            <mat-option value="{{ null }}">No seleccionar</mat-option>
            <mat-option value="asignado">Menú asignado</mat-option>
            <mat-option value="no-asignado">Menú sin asignar</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>

  <div
    *ngIf="!isLoading"
    class="d-flex justify-content-between align-items-center"
    style="padding: 0 36px"
  >
    <div class="col-sm-4 p-0">
      <mat-form-field appearance="outline" class="w-100 hide-hint">
        <input matInput placeholder="Buscar..." (keyup)="applyFilter($event)" />
        <mat-icon matSuffix>
          <i-tabler name="search" class="icon-20"></i-tabler>
        </mat-icon>
      </mat-form-field>
    </div>

    <div>
      <button
        mat-raised-button
        style="background-color: #e95a1a; color: white"
        (click)="openDialogReplicarMenus()"
      >
        Replicar Menús de Servicios
      </button>
    </div>
  </div>

  <div
    *ngIf="isLoading"
    class="d-flex flex-col flex-wrap align-items-center justify-content-center"
    style="padding-bottom: 36px"
  >
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    <p>Cargando Servicios...</p>
  </div>

  <mat-card-content
    [style.display]="
      !isLoading && dataSource.filteredData.length !== 0 ? 'block' : 'none'
    "
    style="padding: 36px"
  >
    <div class="table-responsive">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        class="no-wrap m-t-0 v-middle w-100"
      >
        <ng-container matColumnDef="yearProduct">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 mat-column-yearProduct"
          >
            Año
          </th>
          <td
            mat-cell
            *matCellDef="let serviceProduct"
            class="f-s-14 mat-column-yearProduct"
          >
            {{ serviceProduct.yearProduct }}
          </td>
        </ng-container>
        <ng-container matColumnDef="nombreServicio">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Servicio
          </th>
          <td
            mat-cell
            *matCellDef="let serviceProduct"
            class="f-s-14 custom-column"
          >
            {{ serviceProduct.nombreServicio }}
          </td>
        </ng-container>

        <ng-container matColumnDef="nombreProducto">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Producto
          </th>
          <td
            mat-cell
            *matCellDef="let serviceProduct"
            class="f-s-14 custom-column"
          >
            {{ serviceProduct.nombreProducto }}
          </td>
        </ng-container>

        <ng-container matColumnDef="serviceDay">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Día
          </th>
          <td
            mat-cell
            *matCellDef="let serviceProduct"
            class="f-s-14 custom-column"
          >
            {{ serviceProduct.serviceDay }}
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="estadoServicio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
        <td mat-cell *matCellDef="let element">{{ element.estadoServicio }}</td>
      </ng-container> -->

        <ng-container matColumnDef="categoriaServicio">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Categoría
          </th>
          <td
            mat-cell
            *matCellDef="let serviceProduct"
            class="f-s-14 custom-column"
          >
            {{ serviceProduct.categoriaServicio }}
          </td>
        </ng-container>

        <ng-container matColumnDef="nombreProveedor">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Proveedor
          </th>
          <td
            mat-cell
            *matCellDef="let serviceProduct"
            class="f-s-14 custom-column"
          >
            {{ serviceProduct.nombreProveedor }}
          </td>
        </ng-container>

        <ng-container matColumnDef="locacion">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Locación
          </th>
          <td
            style="max-width: 40px"
            mat-cell
            *matCellDef="let serviceProduct"
            class="f-s-14 custom-column"
          >
            {{ serviceProduct.locacion }}
          </td>
        </ng-container>

        <ng-container matColumnDef="menu">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Menú
          </th>
          <td
            mat-cell
            *matCellDef="let serviceProduct"
            class="f-s-14 custom-column"
          >
            {{ serviceProduct.menu?.nombreMenu || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="asignar">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="f-w-600 f-s-15 custom-column"
          >
            Asignar Menú
          </th>
          <td
            mat-cell
            *matCellDef="let serviceProduct"
            class="f-s-14 custom-column"
          >
            <button
              mat-icon-button
              color="primary"
              (click)="openDialogAsignarMenuComponent(serviceProduct)"
            >
              <mat-icon>restaurant</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <div [hidden]="isLoading" style="width: 100%">
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>
  <div
    *ngIf="!isLoading && dataSource?.filteredData?.length === 0"
    class="d-flex justify-content-center align-items-center"
    style="width: 100%; height: 400px; text-align: center"
  >
    Lo sentimos. No tenemos datos para esta búsqueda.
    <br />Por favor, intenta con otro término.
  </div>
</mat-card>
